import { useEffect } from 'react';
import { prefersReducedMotion, startFaviconLoop } from 'fym-shared/src/music24/faviconMotion';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { useIsDemoAccount } from '../../../accountSelector/useIsDemoAccount';
import { useKitWorkBadge } from './useKitWorkBadge';

/**
 * The bars of the tab favicon dance while a kit asset or an AI reel of the active artist is queued
 * or being made (owner request 2026-10-29). They settle back into the 4 when the work ends. It
 * reads the work summary of the Studio chip, so it adds no request. The demo artist never moves
 * it, and nothing moves when the person asked for less motion.
 */
export function useWorkingFavicon({ enabled }: { enabled: boolean }): void {
  const selectedAccountId = useAccountId();
  const isDemo = useIsDemoAccount();
  const work = useKitWorkBadge(enabled && !isDemo ? selectedAccountId : null);
  const isWorking = work !== undefined && work.working > 0;

  useEffect(() => {
    if (!isWorking || prefersReducedMotion()) {
      return undefined;
    }
    const loop = startFaviconLoop(document);
    return () => loop.stop();
  }, [isWorking]);
}
